import { UseQueryOptions } from '@tanstack/react-query';
import useAppQuery from 'hooks/useAppQuery';
import useAppUser from 'hooks/useAppUser';
import {
  CustomDataFieldUsage,
  GetPreArrivalCustomFieldsResponse,
} from 'models/CustomDataField';
import API from 'services/API';

export const INTERNAL_CUSTOM_DATA_FIELDS_BASE_QUERY_KEY =
  'internal-custom-data-fields';

type ReactQueryOptions = Omit<
  UseQueryOptions<GetPreArrivalCustomFieldsResponse>,
  'queryKey' | 'queryFn'
>;

type UseFetchInternalCustomDataFieldsArgs = {
  usage: CustomDataFieldUsage;
} & ReactQueryOptions;

const useFetchInternalCustomDataFields = ({
  enabled = true,
  usage = CustomDataFieldUsage.PRE_ARRIVAL_FORM,
  ...options
}: UseFetchInternalCustomDataFieldsArgs) => {
  const { agencyUid } = useAppUser();

  return useAppQuery<GetPreArrivalCustomFieldsResponse>({
    queryKey: [INTERNAL_CUSTOM_DATA_FIELDS_BASE_QUERY_KEY, usage],
    queryFn: async () => {
      const response = await API.get<GetPreArrivalCustomFieldsResponse>(
        '/api/internal/custom-data-fields',
        { params: { agencyUid, usage } },
      );

      return response.data;
    },
    enabled,
    ...options,
  });
};

export default useFetchInternalCustomDataFields;
